import type { IResponse } from "@litres-libs/types";
import { rtkqApi } from "../api/rtkqApi";

export const loyaltyApi = rtkqApi.injectEndpoints({
  endpoints: build => ({
    registerLoyalty: build.mutation<IResponse, void>({
      query: () => ({
        url: "/loyalty/api/loyalty/register",
        method: "POST",
      }),
    }),
  }),
});
